import { render, staticRenderFns } from "./RegStep3.vue?vue&type=template&id=c05d98ce&scoped=true"
import script from "./RegStep3.vue?vue&type=script&lang=js"
export * from "./RegStep3.vue?vue&type=script&lang=js"
import style0 from "./RegStep3.vue?vue&type=style&index=0&id=c05d98ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05d98ce",
  null
  
)

export default component.exports